export default __webpack_public_path__ + "41332cc.png";